import { ChangeDetectionStrategy, Component, OnInit, computed, effect, inject } from '@angular/core';
import { Router } from '@angular/router';
import { AuthStore } from '@application/auth.store';

@Component({
  selector: 'app-auth-callback-view',
  templateUrl: './auth-callback-view.component.html',
  styleUrl: './auth-callback-view.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class AuthCallbackViewComponent implements OnInit {
  private router = inject(Router);
  private auth = inject(AuthStore);
  private redirected = false;

  readonly loading = computed(() => !this.auth.ready() || this.auth.initializing());
  readonly authError = computed(() => this.auth.authError());

  constructor() {
    effect(() => {
      if (!this.auth.ready() || this.redirected) return;

      this.redirected = true;
      this.navigateAfterCallback();
    });
  }

  ngOnInit(): void {
    this.auth.completeLoginRedirect().catch(error => {
      console.error('Unable to complete auth callback', error);
    });
  }

  private navigateAfterCallback(): void {
    const target = this.auth.isAuthenticated() ? '/chat' : '/login';
    this.router.navigate([target]).catch(error => {
      console.error('Unable to navigate after auth callback', error);
    });
  }
}
